var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"875212749d12bb2a980ed8b6409b7c287127782c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend@mapistry"]={id:"875212749d12bb2a980ed8b6409b7c287127782c"};
      